var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8896 20.8499H6.10955C5.79187 20.8502 5.48326 20.7439 5.23309 20.5481C4.98291 20.3523 4.80562 20.0783 4.72955 19.7699L2.07955 9.15987C2.05369 9.05658 2.05174 8.94875 2.07383 8.84459C2.09593 8.74044 2.1415 8.64269 2.20707 8.5588C2.27264 8.47491 2.35649 8.40708 2.45223 8.36048C2.54797 8.31387 2.65307 8.28973 2.75955 8.28987H21.2396C21.346 8.28973 21.4511 8.31387 21.5469 8.36048C21.6426 8.40708 21.7265 8.47491 21.792 8.5588C21.8576 8.64269 21.9032 8.74044 21.9253 8.84459C21.9474 8.94875 21.9454 9.05658 21.9196 9.15987L19.2696 19.7699C19.1935 20.0783 19.0162 20.3523 18.766 20.5481C18.5158 20.7439 18.2072 20.8502 17.8896 20.8499V20.8499Z",
    stroke: "#151515",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79941 3.14993L6.89941 8.28993",
    stroke: "#151515",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8799 3.14993L16.7899 8.28993",
    stroke: "#151515",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCart);
export default __webpack_public_path__ + "static/media/ic-cart.dce92157d8a280f012f8f32f152eefde.svg";
export { ForwardRef as ReactComponent };